import Model from '../model';





export default Model.extend( {

} );


// WEBPACK FOOTER //
// ./src/js/model/access/capability.js